import { render, staticRenderFns } from "./MagAddFiltersDialog.vue?vue&type=template&id=da8c6e92"
import script from "./MagAddFiltersDialog.vue?vue&type=script&lang=js"
export * from "./MagAddFiltersDialog.vue?vue&type=script&lang=js"
import style0 from "./MagAddFiltersDialog.vue?vue&type=style&index=0&id=da8c6e92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports